/**
 * Data object representing the customer group list item
 */
export class CustomerGroupImportCustomersListItemDataObject {
	/**
	 * @param {string} id - DB ID of the customer group list item.
	 * @param {CustomerGroupImportCustomersListCustomerDataObject} customer - Customer data.
	 * @param {CustomerGroupImportCustomersType} importType - The way customer is added to the group.
	 */
	constructor(id, customer, importType) {
		this.id = id;
		this.customer = customer;
		this.importType = importType;
	}
}

/**
 * Data object representing a customer in the customer group list item
 */
export class CustomerGroupImportCustomersListCustomerDataObject {
	/**
	 * @param {string} id - DB ID of the customer.
	 * @param {string} firstName - Customer's first name.
	 * @param {string} lastName - Customer's last name.
	 * @param {string} email - Customer's email address.
	 * @param {string} mobilePhoneNumber - Customer's phone number.
	 * @param {Date} dateOfBirth - Customer's date of birth.
	 * @param {string} externalCrmId - CRM ID of the customer in the external system.
	 */
	constructor(id, firstName, lastName, email, mobilePhoneNumber, dateOfBirth, externalCrmId) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.email = email;
		this.mobilePhoneNumber = mobilePhoneNumber;
		this.dateOfBirth = dateOfBirth;
		this.externalCrmId = externalCrmId;
	}
}